const { toggleScroll } = require( "@/utilities/toggleScroll" );

document.addEventListener('DOMContentLoaded', () => {
    initDialogListeners();
});

document.body.addEventListener('htmx:afterSettle', () => {
    initDialogListeners();
});

function initDialogListeners() {
    const triggers = document.querySelectorAll( '[data-dialog]' );
    const closers = document.querySelectorAll( '[data-dialog-close]' );
    const dialogs = document.querySelectorAll( 'dialog.dialog' );

    triggers.forEach( trigger => {
        trigger.addEventListener( 'click', ( e ) => {
            const dialogName = trigger.getAttribute( 'data-dialog' );
            const dialog = document.querySelector( `dialog#${dialogName}` );
            const asModal = trigger.getAttribute( 'data-is-modal' ) ?? 'true';
            const postId = trigger.getAttribute( 'data-post-id' );

            if ( !dialog ) {
                console.warn( 'No dialog with ID: ' + dialogName );
                return;
            }

            openDialog( dialog, asModal === 'true', postId );
        } );
    } );

    closers.forEach( closer => {
        closer.addEventListener( 'click', ( e ) => {
            const dialog = closer.closest( 'dialog' );
            if ( !dialog ) return;
            closeDialog( dialog );
        } );
    } );

    dialogs.forEach( dialog => dialog.addEventListener( 'close', () => toggleScroll( true ) ) );
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function openDialog(dialog, asModal = true, postId = null) {
    asModal ? dialog.showModal() : dialog.show();
    dialog.classList.add('dialog-is-open');
    if (asModal) toggleScroll(false);

    if (postId) {
        document.body._dialogPostId = postId;
        document.body.dispatchEvent(new CustomEvent('dialog-opened', {
            bubbles: true
        }));
    }
}

/**
 *
 * @param {HTMLDialogElement} dialog
 */
function closeDialog( dialog ) {
    const closeHandler = ( e ) => {
        if ( e.target !== dialog ) return;
        dialog.close();
        dialog.removeEventListener( 'transitionend', closeHandler );
        document.body.dispatchEvent(new CustomEvent('dialog-closed'));
    };
    dialog.addEventListener( 'transitionend', closeHandler );
    dialog.classList.remove( 'dialog-is-open' );
}
